import {RulebookStyle} from '../../../../shared/enums/RulebookEnums'
import {UIScrollController} from '../ui_scroll_controller/UIScrollController'
import {getHomepageUrl, navigateToPage} from '../ui_utils/ClientUtils'

export class UIRulebookController extends UIScrollController {
    constructor() {
        UIRulebookController.setupBackButtonListener()
        UIRulebookController.setupLogoButtonListener()

        const rulebookContentElement = document.getElementById('rulebook-content') as HTMLDivElement
        const rulebookContentContainer = rulebookContentElement.getElementsByClassName('rulebook-content-container')[0] as HTMLDivElement
        const rulebookSideNavigationElement = document.getElementById('rulebook-side-navigation') as HTMLDivElement

        super(rulebookContentContainer, rulebookSideNavigationElement, rulebookContentElement, 'side-navigation-link-current-section')

        rulebookContentElement.addEventListener('scroll', () => this.onContentScroll())
        this.setupLinkListener()
        UIRulebookController.setRulebookLinksStyle()
    }

    private static setupBackButtonListener() {
        const backButton = document.getElementById('rulebook-header-back-button') as HTMLAnchorElement | undefined
        if(backButton == undefined) return

        backButton.addEventListener('click', () => {
            navigateToPage(getHomepageUrl())
        })
    }

    private static setupLogoButtonListener() {
        const logoButton = document.getElementById('rulebook-header-logo-button') as HTMLAnchorElement | undefined
        if(logoButton == undefined) return

        logoButton.addEventListener('click', () => {
            navigateToPage(getHomepageUrl())
        })
    }

    private setupLinkListener() {
        document.body.addEventListener('click', (e: MouseEvent) => {
            if(e.target == null) return

            const link = e.target as HTMLElement
            const closestNavigationSectionLink = link.closest('a')
            const isSectionLink = closestNavigationSectionLink?.href.includes('#')
            if(!isSectionLink) return
            if(closestNavigationSectionLink !== null) this.onSidebarClick(e)
        })
    }

    private static setRulebookLinksStyle() {
        const urlParams = new URLSearchParams(window.location.search)
        const rulebookStyle = urlParams.get('style') as RulebookStyle
        if(rulebookStyle === null) return

        document.querySelectorAll('a').forEach((link: HTMLAnchorElement) => {
            const isInternalLink = link.href.startsWith(location.origin)
            if(!isInternalLink) return

            const isSamePage = link.pathname === location.pathname
            if(isSamePage) return

            const url = new URL(link.href)
            url.searchParams.set('style', rulebookStyle)
            link.href = url.toString()
        })
    }
}
